function Footer() {
    const baseName = import.meta.env.VITE_APP_BASE_URL;
    return (

        <footer className="footer absolute w-full bottom-0 text-center text-lg-start bg-light text-muted" style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}>
            <div className="text-center p-4" >
                <div className="container-fluid">
                    <div className="row">
                        <div className="flex justify-center items-center gap-2">
                            <img src={`${baseName}fav-icon.png`} className="w-[40px]"/><span className="text-muted">© {new Date().getFullYear()} Oxford Builders Supplies. All Rights Reserved.</span>
                        </div>

                    </div>
                </div>
            </div>


        </footer>

    );
}

export default Footer;
